import type { TypedDocumentNode } from '@apollo/client';

import MARK_SEEN from './markReleaseNotesSeen.mutation.graphql';
import type {
  MarkReleaseNotesSeenMutation,
  MarkReleaseNotesSeenMutationVariables,
} from './markReleaseNotesSeen.mutation.graphql';
import RELEASE_NOTES from './releaseNotes.query.graphql';
import type { ReleaseNotesQuery, ReleaseNotesQueryVariables } from './releaseNotes.query.graphql';
import UNREAD_SUMMARY from './releaseNotesUnreadSummary.query.graphql';
import type {
  ReleaseNotesUnreadSummaryQuery,
  ReleaseNotesUnreadSummaryQueryVariables,
} from './releaseNotesUnreadSummary.query.graphql';
import UNREAD_COUNT from './releaseNotesUnreadCount.query.graphql';
import type {
  ReleaseNotesUnreadCountQuery,
  ReleaseNotesUnreadCountQueryVariables,
} from './releaseNotesUnreadCount.query.graphql';

export const RELEASE_NOTES_QUERY = RELEASE_NOTES as TypedDocumentNode<
  ReleaseNotesQuery,
  ReleaseNotesQueryVariables
>;
export const RELEASE_NOTES_UNREAD_COUNT_QUERY = UNREAD_COUNT as TypedDocumentNode<
  ReleaseNotesUnreadCountQuery,
  ReleaseNotesUnreadCountQueryVariables
>;
export const RELEASE_NOTES_UNREAD_SUMMARY_QUERY = UNREAD_SUMMARY as TypedDocumentNode<
  ReleaseNotesUnreadSummaryQuery,
  ReleaseNotesUnreadSummaryQueryVariables
>;
export const MARK_RELEASE_NOTES_SEEN_MUTATION = MARK_SEEN as TypedDocumentNode<
  MarkReleaseNotesSeenMutation,
  MarkReleaseNotesSeenMutationVariables
>;

export type ReleaseNoteNode = ReleaseNotesQuery['releaseNotes']['nodes'][number];

/** The log changes a few times a week: no need to poll like a message feed. */
export const RELEASE_NOTES_POLL_MS = 5 * 60_000;

/** Path of the full log. */
export const WHATS_NEW_PATH = '/whats-new';
